"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketReplicationInput = {
    type: "structure",
    required: ["Bucket"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        }
    }
};
//# sourceMappingURL=DeleteBucketReplicationInput.js.map